// extracted by mini-css-extract-plugin
export default {"body":"style_body__luvpq","container":"style_container__76XoJ","logoWrapper":"style_logoWrapper__w3bEE","bodyWrapper":"style_bodyWrapper__kcrNn","bodyDesc":"style_bodyDesc__f+WUI"};